import { axios } from '../helpers/axios'

export const OAuthClientService = () => {
  /**
   * Validates client_id (+ optional redirect_uri) against cms-rest registry.
   * Legacy single-client envs still return valid when credentials exist server-side.
   */
  const validateOAuthClient = async ({ clientId, redirectUri }) => {
    if (!clientId) return { valid: true, skipped: true }
    const params = new URLSearchParams({ client_id: clientId })
    if (redirectUri) params.set('redirect_uri', redirectUri)
    const resp = await axios.get(`/auth/validate-oauth-client?${params.toString()}`)
    return resp?.data || { valid: false, error: 'Sin respuesta de validación' }
  }

  return { validateOAuthClient }
}
